import React from "react";

import { Button, Space, Row } from "@masterteam/mt-design-react";
import { ReactComponent as CloseIcon } from "../../assets/images/close.svg";

import styles from "./AdminFormModal.module.scss";

export default function FormHeader({ onClose, title, Icon }) {
  return (
    <Row justify="between" align="center" className={styles.header}>
      <Space align="center">
        {Icon && <Icon className={styles.icon} />}
        <span className={styles.title}>{title}</span>
      </Space>
      <Button
        fill="none"
        variant="dark"
        shape="square"
        onClick={onClose}
        Icon={CloseIcon}
      />
    </Row>
  );
}
